import Vue from 'vue'

Vue.filter('formatPlan', function (value) {
    let value2 = value.split(";");
    return `${value2[0]}-${value2[1]}门必修课(${value2[2]}-${value2[3]}课时)、${value2[5]}-${value2[6]}门选修课(${value2[7]}-${value2[8]}课时)、${value2[10]}-${value2[11]}门免费课`
})
Vue.filter('formatPlan1', function (value) {
    let value2 = value.split(";");
    return `${value2[0]}-${value2[1]}门、${value2[2]}-${value2[3]}课时`
})
Vue.filter('formatPlan2', function (value) {
    let value2 = value.split(";");
    var val = `${value2[5]}-${value2[6]}门、${value2[7]}-${value2[8]}课时`
    return val
})
// 订单状态
Vue.filter('orderStatus', function(val) {
  switch(val){
    case 0:
    return "正常";
    case 1:
    return "邮寄发票";
    case 2:
    return "退款中";//退款申请
    case 3:
    return "已退款";
    case 4:
    return "退款失败";
    case 5:
    return "退款中";
    case 6:
    return "退款失败";
    case 7:
    return "已退款";//退款成功
  }
  //（0正常，1发票邮寄中，2退款申请，3已退款，4已驳回）
})
// 订单状态
Vue.filter('numToCode', function(val) {
  switch(val){
    case 0:
    return "A";
    case 1:
    return "B";
    case 2:
    return "C";
    case 3:
    return "D";
    case 4:
    return "E";
    case 5:
    return "F";
    case 6:
    return "G";
    case 7:
    return "H";
  }
  //（0正常，1发票邮寄中，2退款申请，3已退款，4已驳回）
})
// 订单状态
Vue.filter('reInvoicedOrder', function(val) {
  switch(val){
    case 0:
    return "待支付";
    case 1:
    return "已支付";
    case 2:
    return "已退款";
    case -1:
    return "已取消";
  }
 
})
// 发票类型
Vue.filter('toInvoiceType', function(val) {
  switch(val){
    case 0:
    return "个人/非企业单位";
    case 1:
    return "企业单位";
    case 2:
    return "集体";
  }})
// 发票状态
Vue.filter('invoiceStatus', function(val) {
  switch(val){
    case 0:
    return "未开发票";
    case 1:
    return "开票中";
    case 2:
    return "已开发票";
    case 3:
    return "补开申请";
    case 4:
    return "已补开";
    case 5:
    return "已驳回";
    case 6:
    return "发票已邮寄";
    case 7:
    return "集体票已开";
    case 8:
    return "发票已邮寄";
    case 9:
    return "集体票已开";
    case -1:
    return "禁止开票";
  }
// /	invoiceStatus 发票状态（0待开票，1开票中，2已开票，3补开申请，4已补开，5已驳回，-1禁止开票）

})
// 补开发票状态
Vue.filter('suppleInvoiceStatus', function(val) {
  switch(val){
    case 0:
    return "发票申请中";
    case 1:
    return "已开票";
    case 2:
    return "已红冲";
    case 3:
    return "已绑定开票";
    case 4:
    return "发票已邮寄";
    case 5:
    return "已驳回";
    case 6:
    return "发票已邮寄";
    case 7:
    return "集体票已开";
    case 8:
    return "发票已邮寄";
    case 9:
    return "集体票已开";
    case -1:
    return "开票驳回";
    case -2:
    return "开票已取消";
    case -3:
    return "开票失败";
  }
})
Vue.filter('formatPlan3', function (value) {
    let value2 = value.split(";");
    return `${value2[10]}-${value2[11]}门`
})
Vue.filter('timeChange', function (value) {
  return value.replace(/-/g,".")
})
//格式化&amp
Vue.filter('deleteAMP', function (value) {
    var t = 0;
    if (value) {
        if (value.indexOf != -1) {
            t = (value.split("&nbsp;")).length - 1
            for (var i = 0; i < t; i++) {
                value = value.replace("&nbsp;", "");
            }
        }
    }

    return value
})
Vue.filter('planType',function(value){
  switch (value) {
    case 0:
      return "固定包"
      case 1:
        return "自修包"
    default:
      break;
  }
})
Vue.filter('classType',function(value){
  switch (value) {
    case 0:
      return "专业科目"
      case 1:
        return "公共科目"
        case 2:
        return "考前辅导课"
    default:
      break;
  }
})

Vue.filter('dtToDate', function(val) {
  if(val.length>=10){
    return val.substring(0, 10)+' '
  }
  else  return val
})
Vue.filter('toKanji', function(val) {
val = val-0
var chnNumChar = ["零","一","二","三","四","五","六","七","八","九","十","十一","十二","十三","十四","十五","十六","十七","十八","十九","二十"];
var chnUnitSection = ["","万","亿","万亿","亿亿"];
var chnUnitChar = ["","十","百","千"];
var str = '', chnstr = '',zero= false,count=0;   //zero为是否进行补零， 第一次进行取余由于为个位数，默认不补零
  if(val<20){
    chnstr = chnNumChar[val];
    
  }else{
      while(val>0){      
      var v = val % 10;  //对数字取余10，得到的数即为个位数
       if(v ==0){                    //如果数字为零，则对字符串进行补零
           if(zero){
               zero = false;        //如果遇到连续多次取余都是0，那么只需补一个零即可
               chnstr = chnNumChar[v] + chnstr;
           }
       }else{
           zero = true;           //第一次取余之后，如果再次取余为零，则需要补零
           str = chnNumChar[v];
           str += chnUnitChar[count];
           chnstr = str + chnstr;
       }
       count++;
       val = Math.floor(val/10);
    
      }   
  }
  return chnstr;
})


// WEBPACK FOOTER //
// ./src/assets/js/filter.js